import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import apiConfig from './url'
import qs from 'qs'
import store from '../store/index'

// 请求失败后统一处理
const errorHandle = (status, message) => {
  // 状态码判断
  switch (status) {
    // 403: 未登录状态，跳转登录页
    case 401:
      // 当没有了权限，清空缓存
      MessageBox(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          parent.postMessage({ msg: status }, '*')
        })
        .catch(() => {
          parent.postMessage(
            {
              flag: 'notification',
              data: {
                type: 'error',
                title: '提示',
                duration: 3000,
                message:
                  '已取消跳转到登录界面！之后可能获取不到数据！请自行跳转登录后重试！',
              },
            },
            '*'
          )
        })
      break
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      // tip('登录过期，请重新登录')
      MessageBox(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          parent.postMessage({ msg: 401 }, '*')
        })
        .catch(() => {
          parent.postMessage({ msg: 401 }, '*')
          Message.closeAll()
        })
      break
    // 404请求不存在
    case 404:
      // tip('请求的资源不存在')
      break
    case 500:
    case 501:
    case 502:
    case 503:
      parent.postMessage(
        {
          flag: 'notification',
          data: {
            type: 'error',
            title: '错误',
            duration: 3000,
            message: '服务不可用或出现服务故障，请联系管理员！',
          },
        },
        '*'
      )
      break
    default:
    // 其他错误提示消息
  }
}

// 创建axios实例
const instance = axios.create({ timeout: 1000 * 12 })

// 设置post请求头
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

const pendingRequest = new Map()

// 用于根据当前请求的信息，生成请求 Key
function generateReqKey(config) {
  const { method, url, params, data } = config
  return [method, url, qs.stringify(params), qs.stringify(data)].join('&')
}

// 用于把当前请求信息添加到pendingRequest对象中
function addPendingRequest(config) {
  const requestKey = generateReqKey(config)
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken((cancel) => {
      if (!pendingRequest.has(requestKey)) {
        pendingRequest.set(requestKey, cancel)
      }
    })
}

// 检查是否存在重复请求，若存在则取消已发的请求
function removePendingRequest(config) {
  const requestKey = generateReqKey(config)
  if (pendingRequest.has(requestKey)) {
    const cancel = pendingRequest.get(requestKey)
    cancel(requestKey)
    pendingRequest.delete(requestKey)
  }
}

// 请求拦截器
instance.interceptors.request.use(
  function (config) {
    removePendingRequest(config)
    addPendingRequest(config)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (res) => {
    if (res.data.status === 403) {
      errorHandle(403, res.data.message)
      return Promise.resolve(res)
    }
    if (res.data.status === 401) {
      return instance
        .post(
          apiConfig.oauth.TOKEN,
          qs.stringify({
            grant_type: 'refresh_token',
            client_id: 'smithy-pc',
            client_secret: 'smithy-pc',
            refresh_token: JSON.parse(localStorage.authInfo).refresh_token,
          })
        )
        .then((response) => {
          // 刷新token也失效，跳转到登录
          if ([0, 401].includes(response.data.status)) {
            errorHandle(401, response.data.message)
            return Promise.reject(response)
          }
          // 刷新token成功，将最新的token更新到header中，同时保存在localStorage中
          const refreshAuthInfo = response.data
          const originAuthInfo = JSON.parse(localStorage.authInfo)
          originAuthInfo.refresh_token = refreshAuthInfo.refresh_token
          originAuthInfo.token = store.state.globalEnv.keycloak.token
          // 获取当前失败的请求
          const config = res.config
          // 重置一下配置
          config.headers.Authorization =
            /* originAuthInfo.token_type +  */ 'Bearer ' +
            store.state.globalEnv.keycloak.token
          config.baseURL = localStorage.getItem('platApp')
          console.log(config, 'urk设置')
          // 重试当前请求并返回promise
          parent.postMessage(
            { msg: localStorage.getItem('authInfo'), flag: 'refresh' },
            '*'
          )
          return instance(config)
        })
        .catch((error) => {
          const { response } = error
          if (response) {
            errorHandle(response.data.status, response.data.message)
          }
          return Promise.reject(error)
        })
    }
    const messages = ['成功', '默认方案不能进行操作']
    if (res.status !== 200) {
      return Promise.reject(res)
    }
    if (!res.data.message || messages.includes(res.data.message)) {
      // 无消息不进行操作
    } else if (!res.data.status) {
      parent.postMessage(
        {
          flag: 'notification',
          data: {
            type: 'error',
            title: '错误',
            duration: 3000,
            message: res.data.message,
          },
        },
        '*'
      )
    } else {
      parent.postMessage(
        {
          flag: 'notification',
          data: {
            type: 'success',
            title: '提示',
            duration: 3000,
            message: res.data.message,
          },
        },
        '*'
      )
    }
    return Promise.resolve(res)
  },
  // 请求失败
  async (error) => {
    const { response } = error
    if (response) {
      errorHandle(response.status, response.data.message)
    }
    return Promise.reject(error)
  }
)

instance.interceptors.request.use(
  (config) => {
    // config.baseURL = location.origin
    // 请求拦截器，添加token请求头
    config.headers.Authorization = store.state.keycloakToken.token
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
